export default "https://cdn-static.gokick.com/assets/afaaccc9c40207d12945800ee9a4df41e308a977/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";